var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.1167,
    y1: 167.46,
    x2: 149.1167,
    y2: 216.73,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E9E9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#E9E9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#E8E8E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#E7E7E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#E7E6E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E4E4E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E4E4E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3E2E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E2E2E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E1E1E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E0E0E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#DFDEDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#DCDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#DBDADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#DADADA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D9D9D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#D8D7D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#D7D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#D7D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#D6D6D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#D5D5D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#D4D4D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#D4D3D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#D3D2D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#D2D2D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#D1D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#D1D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#D0CFD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#CFCFCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#CFCECF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#CECECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#CDCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#CDCCCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#CCCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#CCCBCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#CBCBCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#CBCACB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#CACACA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#C9C8C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#C8C7C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#C7C7C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#C7C6C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C5C4C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#C4C3C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#C3C3C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#C3C2C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#C2C2C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#C2C1C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#C1C0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#C0C0C0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#C0BFC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#BFBFBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#BFBEBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#BEBDBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#BEBDBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#BDBCBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#BCBCBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#BCBBBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#BBBABB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#BAB9BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#BAB9BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#B9B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#B8B8B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#B8B7B8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#B7B7B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#B7B6B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#B6B5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#B6B5B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#B5B4B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#B4B4B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#B4B3B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#B3B2B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#B2B1B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#B2B1B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#B1B0B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#B0B0B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#B0AFB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#AFAEAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#AFAEAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#AEADAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#ADACAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#ACACAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#ACABAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#ABAAAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#ABAAAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#AAA9AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#AAA9AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#A9A8A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#A8A7A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#A7A6A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#A7A6A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#A6A5A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#A6A5A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#A5A4A5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    style: {
      stopColor: "#A4A3A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    style: {
      stopColor: "#A3A2A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    style: {
      stopColor: "#A3A2A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#A2A1A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#A2A1A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    style: {
      stopColor: "#A1A0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A09FA0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M12.4,25c-0.7-1.6-1-3.4-0.8-5.1c0.1-1.7,0.6-3.3,1.5-4.7c0.8-1.3,1.9-2.5,3.2-3.4 c1.4-0.9,2.9-1.5,4.5-1.8c1.7-0.2,3.5-0.1,5.2,0.5c1.5,0.5,2.9,1.3,4,2.4c1.2,1.1,2.1,2.5,2.7,4c1.3,3.1,0.9,6.6-0.9,9.4 c-0.8,1.3-1.8,2.5-3,3.5l-1.9,1.9l-1,0.9h0.2l0.5-0.2l0.6-0.2l0.5-0.3l0.6-0.2l0.5-0.3c0.2-0.1,0.4-0.2,0.5-0.4l0.5-0.3l0.5-0.4 c0.1-0.1,0.3-0.2,0.4-0.4l0.5-0.4l0.4-0.4l0.4-0.5l0.4-0.5l0.3-0.5l0.3-0.5l0.3-0.5l0.3-0.5c0.1-0.2,0.2-0.4,0.2-0.6l0.3-0.5 c0-0.2,0.1-0.4,0.2-0.6c0-0.2,0.1-0.4,0.1-0.6c0.1-0.2,0.1-0.4,0.1-0.6c0.1-0.2,0.1-0.4,0.2-0.6V22c0-0.2,0.1-0.4,0.1-0.6v-1.2 c0-0.2-0.1-0.4-0.1-0.6V19c-0.1-0.2-0.1-0.4-0.2-0.6c0-0.2,0-0.4-0.1-0.6c0-0.2-0.1-0.4-0.1-0.6s-0.2-0.3-0.2-0.5l-0.3-0.6 c0-0.2-0.1-0.4-0.2-0.6L33.3,15L33,14.6l-0.3-0.5l-0.3-0.5L32,13.1l-0.4-0.5l-0.4-0.4l-0.5-0.4l-0.4-0.4l-0.5-0.4l-0.5-0.3l-0.5-0.3 c-0.2-0.2-0.3-0.3-0.5-0.3l-0.6-0.3l-0.5-0.3l-0.6-0.2l-0.5-0.2h-0.6l-0.6-0.3h-4.8l-0.6,0.2h-0.6l-0.5,0.3l-0.6,0.2l-0.6,0.3 l-0.5,0.3c-0.2,0-0.4,0.1-0.5,0.3l-0.5,0.3L15.2,11l-0.5,0.4l-0.5,0.4l-0.4,0.4l-0.4,0.4L13,13.1l-0.4,0.5l-0.3,0.5l-0.4,0.5 c-0.1,0.2-0.2,0.3-0.2,0.5l-0.3,0.5l-0.3,0.6c0,0.2-0.1,0.4-0.2,0.6c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.2-0.1,0.4-0.1,0.6 s-0.1,0.4-0.2,0.6c0,0.2,0,0.4-0.1,0.6v0.6c-0.1,0.2-0.1,0.4-0.1,0.6v1.2c0,0.2,0,0.4,0.1,0.6v0.6c0.1,0.2,0.1,0.4,0.1,0.6l0.2,0.6 c0,0.2,0.1,0.4,0.1,0.6c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.1,0.2,0.3,0.2,0.5l0.3,0.6l0.3,0.5c0,0.2,0.1,0.4,0.2,0.5l0.4,0.5l0.3,0.5 l0.4,0.5l0.4,0.5l0.4,0.4l0.4,0.4l0.5,0.4l0.5,0.4l0.5,0.3c0.1,0.2,0.3,0.3,0.5,0.4l0.5,0.3l0.5,0.2l0.6,0.3l0.6,0.2h0.3l-2.6-2.6 C14.6,28.5,13.4,26.8,12.4,25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M22.6,36.5l1.7-2.1l1-1.1l0.6-0.6l1-0.9l1.9-1.9c1.2-1,2.2-2.2,3-3.5c1.8-2.8,2.2-6.3,0.9-9.4 c-0.6-1.5-1.5-2.9-2.7-4c-1.1-1.1-2.5-1.9-4-2.4c-1.7-0.6-3.5-0.7-5.2-0.5c-1.6,0.3-3.1,0.9-4.5,1.8c-1.3,0.9-2.4,2.1-3.2,3.4 c-0.9,1.4-1.4,3-1.5,4.7c-0.2,1.7,0.1,3.5,0.8,5.1c1,1.8,2.2,3.4,3.7,4.8l2.6,2.7l3.7,3.9H22.6z M18.3,28.7l-0.8-0.5l-0.6-0.5 L16.2,27l-0.5-0.6l-0.6-0.7L14.7,25c-0.1-0.3-0.2-0.6-0.4-0.8c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.3-0.2-0.5-0.2-0.8 c-0.1-0.3-0.1-0.6-0.2-0.8c0-0.2,0-0.4-0.1-0.5c0-0.3-0.1-0.6-0.1-0.9s-0.1-0.5-0.1-0.8s0.1-0.6,0.1-0.9s0.1-0.6,0.1-0.9 s0.1-0.5,0.2-0.8l0.3-0.8c0.1-0.3,0.3-0.5,0.4-0.8l0.5-0.7c0.1-0.3,0.3-0.5,0.5-0.7l0.6-0.6c0.2-0.3,0.4-0.5,0.7-0.6 c0.2-0.2,0.4-0.4,0.7-0.5l0.7-0.5l0.8-0.4l0.9-0.2l0.8-0.3h3.6l0.8,0.3l0.9,0.2c0.2,0.2,0.5,0.3,0.8,0.4l0.7,0.5 c0.3,0.1,0.5,0.3,0.7,0.5c0.3,0.1,0.5,0.3,0.7,0.6l0.6,0.6c0.2,0.2,0.4,0.4,0.5,0.7l0.5,0.7c0.1,0.3,0.2,0.6,0.4,0.8l0.3,0.8 c0,0.3,0.1,0.6,0.2,0.8c0,0.3,0.1,0.6,0.1,0.9v1.7c0,0.3-0.1,0.6-0.1,0.9c-0.1,0.3-0.2,0.5-0.2,0.8L30.9,23 c-0.1,0.2-0.2,0.3-0.2,0.4h-0.1c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.3-0.3,0.5-0.4,0.8l-0.4,0.7l-0.5,0.7L28.5,27l-0.6,0.6l-0.7,0.5 l-0.8,0.5l-0.7,0.3l-0.8,0.3L24,29.4h-3.3l-0.9-0.2L19,28.9L18.3,28.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M13.7,21v-0.8c0.1-0.3,0.1-0.6,0.2-0.9c0-0.3,0.1-0.5,0.2-0.8c0-0.3,0.1-0.6,0.2-0.8 c0.2-0.2,0.3-0.5,0.4-0.8l0.4-0.7l0.6-0.7l0.5-0.6l0.7-0.6l0.6-0.5l0.8-0.4L19,13l0.8-0.3l0.9-0.2H24l0.9,0.2l0.8,0.3l0.7,0.4 l0.8,0.4l0.7,0.5l0.6,0.6l0.6,0.6l0.5,0.7l0.4,0.7c0.1,0.3,0.3,0.5,0.4,0.8c0.1,0.2,0.2,0.5,0.2,0.8l0.3,0.8c0,0.3,0,0.6,0.1,0.9 v1.7c-0.1,0.3-0.1,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.2,0.7c0-0.1,0.1-0.2,0.2-0.4l0.3-0.8c0-0.3,0.1-0.5,0.2-0.8 c0-0.3,0.1-0.6,0.1-0.9v-1.7c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.2-0.2-0.5-0.2-0.8l-0.3-0.8c-0.2-0.2-0.3-0.5-0.4-0.8L30,14.8 c-0.1-0.3-0.3-0.5-0.5-0.7l-0.6-0.6c-0.2-0.3-0.4-0.5-0.7-0.6c-0.2-0.2-0.4-0.4-0.7-0.5l-0.7-0.5c-0.3-0.1-0.6-0.2-0.8-0.4l-0.9-0.2 L24.3,11h-3.6l-0.8,0.3L19,11.5l-0.8,0.4l-0.7,0.5c-0.3,0.1-0.5,0.3-0.7,0.5c-0.3,0.1-0.5,0.3-0.7,0.6l-0.6,0.6 c-0.2,0.2-0.4,0.4-0.5,0.7l-0.5,0.7c-0.1,0.3-0.3,0.5-0.4,0.8L13.8,17c-0.1,0.3-0.1,0.6-0.2,0.8s-0.1,0.6-0.1,0.9s-0.1,0.6-0.1,0.9 s0.1,0.5,0.1,0.8c0,0.3,0.1,0.6,0.1,0.9c0.1,0.1,0.1,0.3,0.1,0.5l0,0L13.7,21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006707949651870303650000010659172495574511022_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.02,
    y1: 172.02,
    x2: 149.02,
    y2: 207.2,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EAEAEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8E8E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#E7E7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#E5E5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#E3E3E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#E2E2E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#E0E0E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DEDEDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DDDDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DBDBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#D9D9DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#D8D8D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#D6D6D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#D4D4D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#D3D3D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#D1D1D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#CFCFD0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#CECECE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#CCCCCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#CACACB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#C9C9C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#C7C7C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#C5C5C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#C4C4C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#C2C2C3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#C0C0C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#BEBEBF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#BDBDBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#BBBBBC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#B9B9BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B8B8B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B6B6B7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#B4B4B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#B3B3B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#B1B1B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#AFAFB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#AEAEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#ACACAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#AAAAAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#A9A9A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#A7A7A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#A5A5A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#A2A2A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#A0A0A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#9F9F9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#9D9D9E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#9B9B9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#9A9A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#989899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#969697"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#959595"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#939394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#919192"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#909090"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8E8E8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8C8C8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#89898A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#878788"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#848485"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#828283"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#818181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#7F7F80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#7D7D7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#7C7C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#7A7A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#787879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#757575"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#737374"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#6E6E6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#6D6D6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#6B6B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#69696A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#666666"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#646465"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#636363"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#616161"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#5F5F60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#5E5E5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#5A5A5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#595959"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#555556"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#545454"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#505051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#4F4F4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#4A4A4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#484848"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#464646"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#434343"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#414141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#404040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#3E3E3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#3C3C3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#3B3B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#393939"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#373737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#363636"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#343434"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#323232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#313131"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#2F2F2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#2D2D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#2C2C2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#2A2A2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#272727"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#232323"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#212122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1E1E1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1C1C1D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#1B1B1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#191919"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#171717"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#171717"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000006707949651870303650000010659172495574511022_)",
    d: "M13.7,21v-0.8c0.1-0.3,0.1-0.6,0.2-0.9 c0-0.3,0.1-0.5,0.2-0.8c0-0.3,0.1-0.6,0.2-0.8c0.2-0.2,0.3-0.5,0.4-0.8l0.4-0.7l0.6-0.7l0.5-0.6l0.7-0.6l0.6-0.5l0.8-0.4L19,13 l0.8-0.3l0.9-0.2H24l0.9,0.2l0.8,0.3l0.7,0.4l0.8,0.4l0.7,0.5l0.6,0.6l0.6,0.6l0.5,0.7l0.4,0.7c0.1,0.3,0.3,0.5,0.4,0.8 c0.1,0.2,0.2,0.5,0.2,0.8l0.3,0.8c0,0.3,0,0.6,0.1,0.9v1.7c-0.1,0.3-0.1,0.5-0.1,0.8c-0.1,0.2-0.2,0.5-0.2,0.7 c0-0.1,0.1-0.2,0.2-0.4l0.3-0.8c0-0.3,0.1-0.5,0.2-0.8c0-0.3,0.1-0.6,0.1-0.9v-1.7c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.2-0.2-0.5-0.2-0.8 l-0.3-0.8c-0.2-0.2-0.3-0.5-0.4-0.8L30,14.8c-0.1-0.3-0.3-0.5-0.5-0.7l-0.6-0.6c-0.2-0.3-0.4-0.5-0.7-0.6c-0.2-0.2-0.4-0.4-0.7-0.5 l-0.7-0.5c-0.3-0.1-0.6-0.2-0.8-0.4l-0.9-0.2L24.3,11h-3.6l-0.8,0.3L19,11.5l-0.8,0.4l-0.7,0.5c-0.3,0.1-0.5,0.3-0.7,0.5 c-0.3,0.1-0.5,0.3-0.7,0.6l-0.6,0.6c-0.2,0.2-0.4,0.4-0.5,0.7l-0.5,0.7c-0.1,0.3-0.3,0.5-0.4,0.8L13.8,17c-0.1,0.3-0.1,0.6-0.2,0.8 s-0.1,0.6-0.1,0.9s-0.1,0.6-0.1,0.9s0.1,0.5,0.1,0.8c0,0.3,0.1,0.6,0.1,0.9c0.1,0.1,0.1,0.3,0.1,0.5l0,0L13.7,21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.8,29.2l0.9,0.2H24l0.9-0.2l0.8-0.3l0.7-0.3l0.8-0.5l0.7-0.5l0.6-0.6l0.6-0.6l0.5-0.7L30,25 c0.1-0.3,0.3-0.5,0.4-0.8c0.1-0.2,0.2-0.5,0.2-0.8h0.1c0-0.2,0.1-0.5,0.2-0.7c0-0.3,0-0.5,0.1-0.8v-1.8c-0.1-0.3-0.1-0.6-0.1-0.9 l-0.3-0.8c0-0.3-0.1-0.6-0.2-0.8c-0.1-0.3-0.3-0.5-0.4-0.8l-0.4-0.7l-0.5-0.7l-0.6-0.6l-0.6-0.6l-0.7-0.5l-0.8-0.4l-0.7-0.4 l-0.8-0.3L24,12.4h-3.3l-0.9,0.2L19,12.9l-0.7,0.4l-0.8,0.4l-0.6,0.5l-0.7,0.6l-0.5,0.6l-0.6,0.7l-0.4,0.7c-0.1,0.3-0.2,0.6-0.4,0.8 c-0.1,0.2-0.2,0.5-0.2,0.8c-0.1,0.3-0.2,0.5-0.2,0.8c-0.1,0.3-0.1,0.6-0.2,0.9v1.7l0,0c0.1,0.2,0.1,0.5,0.2,0.8 c0,0.3,0.1,0.5,0.2,0.8c0,0.3,0.1,0.6,0.2,0.8c0.2,0.2,0.3,0.5,0.4,0.8l0.4,0.7l0.6,0.7l0.5,0.6l0.7,0.6l0.6,0.5l0.8,0.5L19,29 L19.8,29.2z M21.7,28.8H21l-0.8-0.2l-0.8-0.3L18.7,28L18,27.6l-0.6-0.5l-0.6-0.5L16.3,26c-0.2-0.2-0.4-0.4-0.5-0.7l-0.4-0.7 l-0.3-0.8c-0.2-0.2-0.2-0.4-0.3-0.7c-0.1-0.3-0.2-0.5-0.2-0.8c-0.1-0.3-0.1-0.5-0.1-0.8c-0.1-0.3-0.1-0.5-0.1-0.8 c0-0.3,0-0.5,0.1-0.8c0-0.2,0-0.5,0.1-0.7c0-0.3,0.1-0.6,0.2-0.8c0.1-0.3,0.2-0.6,0.3-0.8l0.3-0.7c0.2-0.2,0.3-0.5,0.4-0.7l0.5-0.6 l0.5-0.6l0.6-0.5L18,14l0.7-0.4l0.7-0.3l0.8-0.3l0.8-0.2h3.1l0.8,0.2l0.7,0.3l0.7,0.3L27,14l0.7,0.5l0.6,0.5l0.5,0.6l0.5,0.6 c0.1,0.3,0.2,0.5,0.4,0.7l0.3,0.7l0.3,0.8c0.1,0.2,0.1,0.5,0.2,0.8c0.1,0.3,0.1,0.5,0.1,0.7v1.6c0,0.3-0.1,0.6-0.1,0.8 c0,0.2-0.1,0.5-0.2,0.8L30,23.8l-0.3,0.8c-0.2,0.2-0.3,0.4-0.4,0.6l-0.5,0.7l-0.5,0.6L27.7,27L27,27.5l-0.7,0.4l-0.7,0.3l-0.7,0.3 l-0.8,0.2L21.7,28.8L21.7,28.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.1,28.7l0.8-0.2l0.7-0.3l0.7-0.3l0.7-0.4l0.7-0.5l0.6-0.5l0.5-0.6l0.5-0.7c0.1-0.2,0.2-0.4,0.4-0.6 l0.3-0.8l0.3-0.7c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.3,0.1-0.5,0.1-0.8v-1.6c0-0.2-0.1-0.5-0.1-0.7c0-0.2-0.1-0.6-0.2-0.8L30,17.5 l-0.3-0.7c-0.2-0.2-0.3-0.4-0.4-0.7l-0.5-0.6L28.3,15l-0.6-0.5L27,14l-0.7-0.4l-0.7-0.3l-0.7-0.3l-0.8-0.2H21l-0.8,0.2l-0.8,0.3 l-0.7,0.3L18,14l-0.6,0.5L16.8,15l-0.5,0.6l-0.5,0.6c-0.1,0.2-0.2,0.5-0.4,0.7l-0.3,0.7c-0.1,0.2-0.2,0.5-0.3,0.8 c-0.1,0.2-0.2,0.5-0.2,0.8c-0.1,0.2-0.1,0.5-0.1,0.7c-0.1,0.3-0.1,0.5-0.1,0.8c0,0.3,0,0.5,0.1,0.8c0,0.3,0,0.5,0.1,0.8 c0,0.3,0.1,0.5,0.2,0.8c0.1,0.3,0.1,0.5,0.3,0.7l0.3,0.8l0.4,0.6c0.1,0.3,0.3,0.5,0.5,0.7l0.5,0.6l0.6,0.5l0.6,0.5l0.7,0.4l0.7,0.3 l0.8,0.3l0.8,0.2H24.1z M30.2,21.5v0.2c-0.1,2.2-1.2,4.2-3,5.5l0,0c0-0.1,0.2-4.2-0.9-6.2l0,0C26.4,21,29.5,20.5,30.2,21.5z  M29.4,19v0.3l-0.2,0.3L29,19.9L28.7,20l-0.3,0.2h-1.5L26.6,20l-0.3-0.2l-0.2-0.3l-0.2-0.3c0-0.1,0-0.2-0.1-0.3v-0.7 c0.1-0.1,0.1-0.3,0.1-0.4l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.2l0.3-0.3h2l0.3,0.3c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0l0.2,0.3L29.4,19 L29.4,19z M24.5,17.5c0,0.1,0,0.2-0.1,0.3l-0.2,0.4c0,0.1-0.1,0.2-0.2,0.3l-0.3,0.2L23.4,19h-1.5l-0.4-0.2l-0.3-0.2L21,18.2 c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.2-0.1-0.3v-0.8c0-0.1,0.1-0.3,0.1-0.4L21,16l0.2-0.3l0.3-0.2l0.4-0.2h1.5l0.3,0.2l0.3,0.2 l0.2,0.3l0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.1,0.4C24.6,17.3,24.6,17.4,24.5,17.5z M15.5,18.2v-0.4l0.3-0.3l0.2-0.3 l0.3-0.2l0.3-0.2H18l0.3,0.2l0.3,0.2l0.2,0.3l0.2,0.3v1.4l-0.2,0.3l-0.2,0.3L18.3,20L18,20.2h-1.4L16.3,20L16,19.9l-0.2-0.3 l-0.2-0.3v-1H15.5z M18,27.3c-1.9-1.3-3.2-3.4-3.4-5.7v-0.2c0.3-0.2,1.2-0.9,4.2-0.5l0,0C18.7,21,18,22.1,18,27.3L18,27.3z  M20.4,28.3c-0.2,0-0.3-0.2-0.3-0.4v-4.7l-0.4,5l-1.1-0.6l-0.2-0.2c0-0.7,0-2.8,0.1-4.2c0.1-0.9,0.4-1.7,0.9-2.5 c0.8-1.4,4.1-1.1,4.6-1h0.1c0.8,0.1,1.5,0.5,1.9,1.2c0.9,1.4,0.9,6,0.9,6v0.3c-0.1,0.1-0.1,0.2-0.2,0.2L25.6,28l-0.4-4.5v4.3 c0,0.2-0.1,0.3-0.3,0.4C23.5,28.8,21.9,28.9,20.4,28.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161604660273016167750000014731232408616634525_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.1124,
    y1: 175.55,
    x2: 149.1124,
    y2: 207.99,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7EFF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8F0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D8F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DDF2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DDF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E2F4F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E9F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#E9F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EEF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F1F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F1FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FAFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000161604660273016167750000014731232408616634525_)",
    d: "M24.1,28.7l0.8-0.2l0.7-0.3l0.7-0.3l0.7-0.4 l0.7-0.5l0.6-0.5l0.5-0.6l0.5-0.7c0.1-0.2,0.2-0.4,0.4-0.6l0.3-0.8l0.3-0.7c0.1-0.3,0.1-0.5,0.2-0.8c0.1-0.3,0.1-0.5,0.1-0.8v-1.6 c0-0.2-0.1-0.5-0.1-0.7c0-0.2-0.1-0.6-0.2-0.8L30,17.5l-0.3-0.7c-0.2-0.2-0.3-0.4-0.4-0.7l-0.5-0.6L28.3,15l-0.6-0.5L27,14l-0.7-0.4 l-0.7-0.3l-0.7-0.3l-0.8-0.2H21l-0.8,0.2l-0.8,0.3l-0.7,0.3L18,14l-0.6,0.5L16.8,15l-0.5,0.6l-0.5,0.6c-0.1,0.2-0.2,0.5-0.4,0.7 l-0.3,0.7c-0.1,0.2-0.2,0.5-0.3,0.8c-0.1,0.2-0.2,0.5-0.2,0.8c-0.1,0.2-0.1,0.5-0.1,0.7c-0.1,0.3-0.1,0.5-0.1,0.8 c0,0.3,0,0.5,0.1,0.8c0,0.3,0,0.5,0.1,0.8c0,0.3,0.1,0.5,0.2,0.8c0.1,0.3,0.1,0.5,0.3,0.7l0.3,0.8l0.4,0.6c0.1,0.3,0.3,0.5,0.5,0.7 l0.5,0.6l0.6,0.5l0.6,0.5l0.7,0.4l0.7,0.3l0.8,0.3l0.8,0.2H24.1z M30.2,21.5v0.2c-0.1,2.2-1.2,4.2-3,5.5l0,0c0-0.1,0.2-4.2-0.9-6.2 l0,0C26.4,21,29.5,20.5,30.2,21.5z M29.4,19v0.3l-0.2,0.3L29,19.9L28.7,20l-0.3,0.2h-1.5L26.6,20l-0.3-0.2l-0.2-0.3l-0.2-0.3 c0-0.1,0-0.2-0.1-0.3v-0.7c0.1-0.1,0.1-0.3,0.1-0.4l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.2l0.3-0.3h2l0.3,0.3c0.1,0,0.2,0.1,0.2,0.2 c0,0,0,0,0,0l0.2,0.3L29.4,19L29.4,19z M24.5,17.5c0,0.1,0,0.2-0.1,0.3l-0.2,0.4c0,0.1-0.1,0.2-0.2,0.3l-0.3,0.2L23.4,19h-1.5 l-0.4-0.2l-0.3-0.2L21,18.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.2-0.1-0.3v-0.8c0-0.1,0.1-0.3,0.1-0.4L21,16l0.2-0.3l0.3-0.2 l0.4-0.2h1.5l0.3,0.2l0.3,0.2l0.2,0.3l0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.1,0.4C24.6,17.3,24.6,17.4,24.5,17.5z  M15.5,18.2v-0.4l0.3-0.3l0.2-0.3l0.3-0.2l0.3-0.2H18l0.3,0.2l0.3,0.2l0.2,0.3l0.2,0.3v1.4l-0.2,0.3l-0.2,0.3L18.3,20L18,20.2h-1.4 L16.3,20L16,19.9l-0.2-0.3l-0.2-0.3v-1H15.5z M18,27.3c-1.9-1.3-3.2-3.4-3.4-5.7v-0.2c0.3-0.2,1.2-0.9,4.2-0.5l0,0 C18.7,21,18,22.1,18,27.3L18,27.3z M20.4,28.3c-0.2,0-0.3-0.2-0.3-0.4v-4.7l-0.4,5l-1.1-0.6l-0.2-0.2c0-0.7,0-2.8,0.1-4.2 c0.1-0.9,0.4-1.7,0.9-2.5c0.8-1.4,4.1-1.1,4.6-1h0.1c0.8,0.1,1.5,0.5,1.9,1.2c0.9,1.4,0.9,6,0.9,6v0.3c-0.1,0.1-0.1,0.2-0.2,0.2 L25.6,28l-0.4-4.5v4.3c0,0.2-0.1,0.3-0.3,0.4C23.5,28.8,21.9,28.9,20.4,28.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M15.6,19.2l0.2,0.3l0.2,0.3l0.3,0.2l0.3,0.2H18l0.3-0.2l0.3-0.2l0.2-0.3l0.2-0.3v-1.4l-0.2-0.3l-0.2-0.3 L18.3,17L18,16.9h-1.4L16.3,17L16,17.2l-0.2,0.3l-0.2,0.3V19.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084488876130463756190000008027447289296616088_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.72,
    y1: 175.55,
    x2: 138.72,
    y2: 207.99,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7EFF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8F0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D8F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DDF2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DDF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E2F4F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E9F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#E9F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EEF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F1F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F1FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FAFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000084488876130463756190000008027447289296616088_)",
    d: "M15.6,19.2l0.2,0.3l0.2,0.3l0.3,0.2l0.3,0.2H18 l0.3-0.2l0.3-0.2l0.2-0.3l0.2-0.3v-1.4l-0.2-0.3l-0.2-0.3L18.3,17L18,16.9h-1.4L16.3,17L16,17.2l-0.2,0.3l-0.2,0.3V19.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168095276754322157890000004174495369974645433_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.72,
    y1: 183.89,
    x2: 138.72,
    y2: 191.17,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9AF8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#F9AE8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#F9AD8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#F9AD8D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#F9AC8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#F9AB8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#F8AA8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#F8A989"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#F8A988"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#F8A888"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#F8A787"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#F8A686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#F8A585"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#F8A484"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#F8A483"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#F8A382"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F8A282"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#F8A181"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#F8A080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#F7A07F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F79F7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#F79E7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#F79D7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#F79C7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F79B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F79B7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F79A79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F79978"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F79877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F79777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F79776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F79675"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F79574"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#F69473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#F69372"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#F69271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#F69271"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#F69170"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#F6906F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#F68F6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#F68E6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#F68E6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#F68D6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#F68C6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#F68B6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#F68A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#F58968"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#F58967"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#F58866"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#F58765"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#F58665"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#F58564"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#F58563"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#F58462"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#F58361"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#F58260"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#F58160"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#F5805F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#F5805E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F57F5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#F47E5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F47D5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#F47C5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#F47C5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F47B59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#F47A58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F47957"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#F47856"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#F47755"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#F47754"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#F47654"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#F47553"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#F47452"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#F47351"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#F37350"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#F3724F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#F3714E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#F3704E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#F36F4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#F36E4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#F36E4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#F36D4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#F36C49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#F36B48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#F36A48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#F36A47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#F36946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#F26845"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#F26744"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#F26643"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#F26543"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#F26542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#F26441"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#F26340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#F2623F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#F2613E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#F2613D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#F2603D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F25F3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#F25E3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#F25D3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#F15C39"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#F15C38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#F15B37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#F15A37"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#F15936"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#F15835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F15834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#F15733"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#F15632"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#F15531"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#F15431"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F15330"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#F1532F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#F0522E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#F0512D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F0502C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#F04F2C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#F04F2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    style: {
      stopColor: "#F04E2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#F04D29"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F04C28"
    }
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000168095276754322157890000004174495369974645433_)",
    d: "M15.6,19.2l0.2,0.3l0.2,0.3l0.3,0.2l0.3,0.2H18 l0.3-0.2l0.3-0.2l0.2-0.3l0.2-0.3v-1.4l-0.2-0.3l-0.2-0.3L18.3,17L18,16.9h-1.4L16.3,17L16,17.2l-0.2,0.3l-0.2,0.3V19.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.4,16.4L24.2,16L24,15.8l-0.3-0.2l-0.3-0.2h-1.5l-0.4,0.2l-0.3,0.2L21,16l-0.2,0.3c0,0.1-0.1,0.3-0.1,0.4 v0.8c0,0.1,0.1,0.2,0.1,0.3s0.1,0.3,0.2,0.4l0.2,0.3l0.3,0.2l0.4,0.2h1.5l0.3-0.2l0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3l0.2-0.4 c0.1-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3-0.1-0.4C24.5,16.6,24.5,16.5,24.4,16.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086656164780484276070000004341423511084660391_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.4201,
    y1: 175.55,
    x2: 149.4201,
    y2: 207.99,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7EFF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8F0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D8F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DDF2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DDF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E2F4F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E9F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#E9F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EEF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F1F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F1FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FAFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000086656164780484276070000004341423511084660391_)",
    d: "M24.4,16.4L24.2,16L24,15.8l-0.3-0.2l-0.3-0.2 h-1.5l-0.4,0.2l-0.3,0.2L21,16l-0.2,0.3c0,0.1-0.1,0.3-0.1,0.4v0.8c0,0.1,0.1,0.2,0.1,0.3s0.1,0.3,0.2,0.4l0.2,0.3l0.3,0.2l0.4,0.2 h1.5l0.3-0.2l0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3l0.2-0.4c0.1-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3-0.1-0.4 C24.5,16.6,24.5,16.5,24.4,16.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071554514107484106770000003195061680932816286_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.4201,
    y1: 180.73,
    x2: 149.4201,
    y2: 188.53,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFE1B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AFE1B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#AEE0B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#ADE0B4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#ADE0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#ACE0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#ACE0B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#ABDFB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#AADFB1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#AADFB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#A9DFB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#A8DEAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#A8DEAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#A7DEAE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#A7DEAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#A6DDAD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#A5DDAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#A5DDAC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#A4DDAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#A4DDAB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#A3DCAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#A2DCA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#A2DCA9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#A1DCA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#A0DBA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#A0DBA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#9FDBA7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#9FDBA6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#9EDAA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#9DDAA5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#9DDAA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#9CDAA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9CD9A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9BD9A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#9AD9A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#9AD9A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#99D9A1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#98D8A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#98D8A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#97D89F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#97D89F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#96D79E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#95D79D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#95D79D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#94D79C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#93D69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#93D69B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#92D69B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#92D69A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#91D699"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#90D599"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#90D598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#8FD598"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8FD597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8ED497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#8DD496"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8DD495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#8CD495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#8BD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#8BD394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#8AD393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#8AD393"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#89D292"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#88D291"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#88D291"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#87D290"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#86D290"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#86D18F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#85D18F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#85D18E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#84D18D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#83D08D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#83D08C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#82D08C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#82D08B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#81CF8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#80CF8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#80CF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#7FCF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#7ECF88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#7ECE88"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#7DCE87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#7DCE87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#7CCE86"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#7BCD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#7BCD85"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#7ACD84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#7ACD84"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#79CC83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#78CC83"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#78CC82"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#77CC81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#76CB81"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#76CB80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#75CB80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#75CB7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#74CB7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#73CA7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#73CA7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#72CA7D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#71CA7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#71C97C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#70C97B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#70C97B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#6FC97A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#6EC879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#6EC879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#6DC878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#6DC878"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#6CC877"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#6BC777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#6BC776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#6AC775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#69C775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#69C674"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#68C674"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#68C673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#67C673"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#66C572"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#66C571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#65C571"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#64C570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#64C470"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#63C46F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#63C46F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#62C46E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#61C46D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#61C36D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#60C36C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#60C36C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#5FC36B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#5EC26B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#5EC26A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#5DC269"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#5CC269"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#5CC168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#5BC168"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#5BC167"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#5AC167"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#59C166"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#59C066"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#58C065"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#58C064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#57C064"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#56BF63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#56BF63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#55BF62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#54BF62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#54BE61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#53BE60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#53BE60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#52BE5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#51BE5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#51BD5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#50BD5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#4FBD5D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#4FBD5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#4EBC5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#4EBC5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#4DBC5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#4CBC5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#4CBB5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#4BBB59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#4BBB58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#4ABB58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#49BA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#49BA57"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#48BA56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#47BA56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#47BA55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#46B954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#46B954"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#45B953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#44B953"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#44B852"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#43B852"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#42B851"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#42B850"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#41B750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#41B74F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#40B74F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#3FB74E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#3FB74E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#3EB64D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#3EB64C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#3DB64C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#3CB64B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#3CB54B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#3BB54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#3BB54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3BB54A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000071554514107484106770000003195061680932816286_)",
    d: "M24.4,16.4L24.2,16L24,15.8l-0.3-0.2l-0.3-0.2 h-1.5l-0.4,0.2l-0.3,0.2L21,16l-0.2,0.3c0,0.1-0.1,0.3-0.1,0.4v0.8c0,0.1,0.1,0.2,0.1,0.3s0.1,0.3,0.2,0.4l0.2,0.3l0.3,0.2l0.4,0.2 h1.5l0.3-0.2l0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3l0.2-0.4c0.1-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3-0.1-0.4 C24.5,16.6,24.5,16.5,24.4,16.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M29.3,17.9l-0.2-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0L28.6,17h-2l-0.3,0.3c-0.1,0-0.1,0.1-0.2,0.2l-0.2,0.3 c0,0.1,0,0.3-0.1,0.4V19c0.1,0.1,0.1,0.2,0.1,0.3l0.2,0.3l0.2,0.3l0.3,0.2l0.3,0.2h1.4l0.3-0.2l0.3-0.2l0.2-0.3l0.2-0.3 C29.3,19.2,29.3,17.9,29.3,17.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114062346817081337580000002232414847465633977_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.22,
    y1: 175.55,
    x2: 159.22,
    y2: 207.99,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D7EFF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D8F0F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D8F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#D9F0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF0F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#DAF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#DBF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DCF1F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#DDF2F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DDF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#DEF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF2F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#DFF3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E0F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E1F3F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#E2F4F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E3F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E4F4FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E5F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#E6F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F5FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#E7F6FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E8F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#E9F6FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#E9F7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#EAF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#EBF7FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ECF8FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EDF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#EEF8FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#EFF9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F0F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#F1F9FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F1FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#F2FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F3FAFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F4FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F5FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FBFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#F6FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#F7FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F8FCFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#F9FDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FAFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FBFDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FCFEFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FDFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#FEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000114062346817081337580000002232414847465633977_)",
    d: "M29.3,17.9l-0.2-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0 L28.6,17h-2l-0.3,0.3c-0.1,0-0.1,0.1-0.2,0.2l-0.2,0.3c0,0.1,0,0.3-0.1,0.4V19c0.1,0.1,0.1,0.2,0.1,0.3l0.2,0.3l0.2,0.3l0.3,0.2 l0.3,0.2h1.4l0.3-0.2l0.3-0.2l0.2-0.3l0.2-0.3C29.3,19.2,29.3,17.9,29.3,17.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147934368797698228630000014976303967668748707_",
    gradientUnits: "userSpaceOnUse",
    x1: 159.22,
    y1: 183.91,
    x2: 159.22,
    y2: 191.19,
    gradientTransform: "matrix(0.5 0 0 0.5 -52.06 -75.165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBEAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CBEAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#CAE9F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#C9E9F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#C9E9F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#C8E8F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    style: {
      stopColor: "#C7E8F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C6E8F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    style: {
      stopColor: "#C6E8F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#C5E7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#C4E7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    style: {
      stopColor: "#C3E7F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#C3E6F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#C2E6F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    style: {
      stopColor: "#C1E6F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#C1E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "#C0E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#BFE5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#BEE5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    style: {
      stopColor: "#BEE4F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#BDE4F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    style: {
      stopColor: "#BCE4F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#BBE3F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#BBE3F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    style: {
      stopColor: "#BAE3F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B9E2F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "#B8E2F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#B8E2F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#B7E2F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    style: {
      stopColor: "#B6E1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B6E1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#B5E1F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#B4E0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#B3E0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    style: {
      stopColor: "#B3E0EF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#B2DFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#B1DFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#B0DFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#B0DFEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#AFDEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#AEDEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#AEDEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "#ADDDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ACDDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    style: {
      stopColor: "#ABDDEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#ABDCED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#AADCED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#A9DCED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#A8DCED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    style: {
      stopColor: "#A8DBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#A7DBED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#A6DBEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#A6DAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#A5DAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#A4DAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#A3DAEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#A3D9EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    style: {
      stopColor: "#A2D9EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#A1D9EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#A0D8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#A0D8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#9FD8EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    style: {
      stopColor: "#9ED7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#9ED7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#9DD7EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#9CD7EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#9BD6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#9BD6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#9AD6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#99D5EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    style: {
      stopColor: "#98D5EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#98D5E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    style: {
      stopColor: "#97D4E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#96D4E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#96D4E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    style: {
      stopColor: "#95D4E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#94D3E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#93D3E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "#93D3E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#92D2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    style: {
      stopColor: "#91D2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#90D2E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#90D1E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#8FD1E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#8ED1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#8DD1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#8DD0E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#8CD0E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    style: {
      stopColor: "#8BD0E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#8BCFE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#8ACFE7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#89CFE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#88CEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#88CEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#87CEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    style: {
      stopColor: "#86CEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#85CDE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#85CDE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "#84CDE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#83CCE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#83CCE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#82CCE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#81CBE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#80CBE5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#80CBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#7FCBE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    style: {
      stopColor: "#7ECAE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#7DCAE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#7DCAE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#7CC9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#7BC9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#7BC9E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#7AC9E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#79C8E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#78C8E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#78C8E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    style: {
      stopColor: "#77C7E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#76C7E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#75C7E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#75C6E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#74C6E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#73C6E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#73C6E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#72C5E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#71C5E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#70C5E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    style: {
      stopColor: "#70C4E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#6FC4E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#6EC4E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#6DC3E1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#6DC3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    style: {
      stopColor: "#6CC3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#6BC3E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#6AC2E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    style: {
      stopColor: "#6AC2E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#69C2E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#68C1E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#68C1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#67C1DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    style: {
      stopColor: "#66C0DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#65C0DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#65C0DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#64C0DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#63BFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    style: {
      stopColor: "#62BFDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#62BFDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#61BEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#60BEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#60BEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#5FBDDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#5EBDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#5DBDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    style: {
      stopColor: "#5DBDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#5CBCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "#5BBCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#5ABCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#5ABBDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#59BBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#58BBDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#58BADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#57BADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#56BADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    style: {
      stopColor: "#55BADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#55B9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#54B9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    style: {
      stopColor: "#53B9DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#52B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    style: {
      stopColor: "#52B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#51B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#50B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    style: {
      stopColor: "#50B7DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#4FB7DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    style: {
      stopColor: "#4EB7DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#4DB6DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#4DB6DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#4CB6DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#4BB5D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    style: {
      stopColor: "#4AB5D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#4AB5D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#49B5D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#48B4D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#48B4D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#47B4D9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#46B3D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#45B3D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#45B3D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#44B2D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#43B2D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#42B2D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#42B2D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#41B1D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#40B1D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#3FB1D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    style: {
      stopColor: "#3FB0D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#3EB0D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#3DB0D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#3DAFD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#3CAFD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    style: {
      stopColor: "#3BAFD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#3AAFD6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    style: {
      stopColor: "#3AAED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#39AED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#38AED6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#37ADD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#37ADD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#36ADD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#35ACD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#35ACD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#34ACD5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#33ACD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#32ABD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    style: {
      stopColor: "#32ABD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#31ABD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#30AAD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#2FAAD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#2FAAD4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    style: {
      stopColor: "#2EAAD3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#2DA9D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#2DA9D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#2CA9D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#2BA8D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#2AA8D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#2AA8D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    style: {
      stopColor: "#29A7D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#28A7D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#27A7D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#27A7D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#26A6D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#25A6D2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#25A6D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "#24A5D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#23A5D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#23A5D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#23A5D1"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000147934368797698228630000014976303967668748707_)",
    d: "M29.3,17.9l-0.2-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0 L28.6,17h-2l-0.3,0.3c-0.1,0-0.1,0.1-0.2,0.2l-0.2,0.3c0,0.1,0,0.3-0.1,0.4V19c0.1,0.1,0.1,0.2,0.1,0.3l0.2,0.3l0.2,0.3l0.3,0.2 l0.3,0.2h1.4l0.3-0.2l0.3-0.2l0.2-0.3l0.2-0.3C29.3,19.2,29.3,17.9,29.3,17.9z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4024",
    d: "M18.9,21L18.9,21c-3-0.4-3.9,0.3-4.2,0.5v0.2c0.2,2.3,1.5,4.4,3.4,5.7h0.1C18.1,22.2,18.8,21.2,18.9,21z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#079A49",
    d: "M24.9,28.2c0.2-0.1,0.3-0.2,0.3-0.4v-4.3l0.4,4.5l1.1-0.6c0.1,0,0.1-0.1,0.2-0.2V27c0,0,0-4.6-0.9-6 c-0.4-0.7-1.1-1.1-1.9-1.2H24c-0.5-0.1-3.8-0.4-4.6,1c-0.5,0.8-0.8,1.6-0.9,2.5c-0.1,1.4-0.1,3.5-0.1,4.2l0.2,0.2l1.1,0.6l0.4-5V28 c0,0.2,0.1,0.4,0.3,0.4C21.9,28.9,23.5,28.8,24.9,28.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B7AAA",
    d: "M26.3,21L26.3,21c1.1,2,0.9,6.1,0.9,6.2l0,0c1.8-1.3,2.9-3.3,3-5.5v-0.2C29.5,20.5,26.4,21,26.3,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.8d22926af6a9841fdb056d7bd43f2207.svg";
export { ForwardRef as ReactComponent };